// The picture over a centred auth pane, on Soft — the tilted tiles of the
// style lab (V3 LoginModal, 2026-10-09): the three ways in on graphite tiles
// for the chooser; one large blue tile with a glyph for a pane that is about
// one thing (confirm, open in a browser, the OAuth return). It stands where
// the pixel goat stood. Decorative: the pane's heading says what it is.

import { ArrowSquareOutIcon, ShieldCheckIcon, SignInIcon } from '@phosphor-icons/react'
import { TelegramGlyph } from '../common/SocialLinks'
import { TonMark } from '../exchange/icons'
import { Tile } from '../ui/Tile'
import { GustMark } from '../ui/icons/GustMark'
import styles from './AuthShell.module.css'

export type AuthHeroKind = 'ways' | 'confirm' | 'browser' | 'signin'

export function AuthHero({ kind }: { kind: AuthHeroKind }) {
  if (kind === 'ways') {
    return (
      <div className={styles.hero} aria-hidden="true">
        <Tile tone="graphite" className={`${styles.heroTile} ${styles.heroLeft}`}>
          <span className={styles.telegram}>
            <TelegramGlyph size={28} />
          </span>
        </Tile>
        <Tile tone="graphite" className={`${styles.heroTile} ${styles.heroMid}`}>
          <GustMark height={28} />
        </Tile>
        <Tile tone="graphite" className={`${styles.heroTile} ${styles.heroRight}`}>
          <TonMark size={30} />
        </Tile>
      </div>
    )
  }
  return (
    <div className={styles.hero} aria-hidden="true">
      <Tile tone="blue" large>
        {kind === 'confirm' ? (
          <ShieldCheckIcon size={26} weight="fill" />
        ) : kind === 'browser' ? (
          <ArrowSquareOutIcon size={26} weight="fill" />
        ) : (
          <SignInIcon size={26} weight="fill" />
        )}
      </Tile>
    </div>
  )
}
